import React, { useContext } from 'react'
import Button from "@common/Button";
import {BrandContext} from "@context/BrandContext";

const EndActivity = ({step, handleBack}) => {
    const brandConfig = useContext(BrandContext);

    return (
        <div className="ch-trail-end-activity">
            <h3>Congratulations!</h3>
            <p>You have completed this {brandConfig.taskName}.</p>
            <Button type="text" onClick={handleBack}>
                Return to {brandConfig.tasksName}
            </Button>
        </div>
    )
}

export default EndActivity
